import { render, staticRenderFns } from "./LinkTextRouter.vue?vue&type=template&id=0d3de479&scoped=true"
import script from "./LinkTextRouter.vue?vue&type=script&lang=js"
export * from "./LinkTextRouter.vue?vue&type=script&lang=js"
import style0 from "./LinkTextRouter.vue?vue&type=style&index=0&id=0d3de479&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3de479",
  null
  
)

export default component.exports